import React from 'react';
import { toArray } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import { hasCashbackOffline } from '../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';
import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import HowItWorksComponent from '../../HowItWorksComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './AloConfirmationPage.scss';

export class AloConfirmationPage extends React.Component {
    render() {
        const { i18n, partners } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-alo-confirmation">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.TOOLBAR_POST_INSTALL_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <div className="confirmation">
                    <h3>
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbars/picto-check.svg`}
                            width="23"
                            height="18"
                        />
                        {i18n.TEXT1}
                    </h3>
                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT2, partners)}</p>
                </div>
                <div className="button">
                    <LinkButtonComponent
                        to={PATH.CASHBACK_OFFLINE}
                        text={i18n.BUTTON}
                        title={i18n.BUTTON}
                        color="sixth"
                    />
                </div>
                <div>
                    <HowItWorksComponent showTitle isOffline showAloOnly />
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ALO,
        isAuthenticated: state.authentication.isAuthenticated,
        partners: toArray(state.partner.partners).filter(partner => hasCashbackOffline(partner))
            .length
    };
};

export default withTemplate(connect(mapStateToProps)(AloConfirmationPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/alo/AloConfirmationPage.js